import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetcher } from '../../../helpers/fetcher';
import { SET_CHECK_DATA, SET_SYST_ERROR } from '../../../actions/checks';
import { configApiLinks } from '../../../configApiLinks';

export const useDiscountLoyaltyCards = () => {
  const dispatch = useDispatch();
  const clearDiscountLoyaltyCard = (receiptWrapId) => {
    fetcher(
      configApiLinks.clearDiscountLoyaltyCard,
      'POST',
      { receiptWrapId }
    )
      .then((data) => {
        dispatch({ type: SET_CHECK_DATA, data });
      })
      .catch((error) => {
        dispatch({ type: SET_SYST_ERROR, error });
      });
  };

  return {
    clearDiscountLoyaltyCard,
  };
};
